import type { LifecycleHook } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/types';
import type { propertyToMethodMap } from '../map-field-property-to-api-method';

export const MULTI_APP_CONFLICT_ERROR = 'MULTI_APP_CONFLICT_ERROR';

export type ConflictError = {
	type: typeof MULTI_APP_CONFLICT_ERROR;
	lifecycleHook: LifecycleHook;
	message: string;
	method?: (typeof propertyToMethodMap)[keyof typeof propertyToMethodMap];
	fieldType?: string;
	fieldId?: string;
};
